const DB_NAME = 'flyer-font-cache-v2';
const STORE = 'binaries';
const DB_VERSION = 1;

let dbPromise = null;

function openFontCacheDb() {
  if (typeof indexedDB === 'undefined') return Promise.resolve(null);
  if (!dbPromise) {
    dbPromise = new Promise((resolve) => {
      try {
        const req = indexedDB.open(DB_NAME, DB_VERSION);
        req.onupgradeneeded = () => {
          const db = req.result;
          if (!db.objectStoreNames.contains(STORE)) {
            db.createObjectStore(STORE);
          }
        };
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => resolve(null);
      } catch {
        resolve(null);
      }
    });
  }
  return dbPromise;
}

/** @returns {Promise<ArrayBuffer|null>} */
export async function getLocalFontBinary(cacheKey) {
  const db = await openFontCacheDb();
  if (!db || !cacheKey) return null;
  return new Promise((resolve) => {
    try {
      const tx = db.transaction(STORE, 'readonly');
      const req = tx.objectStore(STORE).get(String(cacheKey));
      req.onsuccess = () => {
        const val = req.result;
        resolve(val instanceof ArrayBuffer ? val : null);
      };
      req.onerror = () => resolve(null);
    } catch {
      resolve(null);
    }
  });
}

/** @returns {Promise<void>} */
export async function putLocalFontBinary(cacheKey, buffer) {
  if (!(buffer instanceof ArrayBuffer) || !cacheKey) return;
  const db = await openFontCacheDb();
  if (!db) return;
  return new Promise((resolve) => {
    try {
      const tx = db.transaction(STORE, 'readwrite');
      tx.objectStore(STORE).put(buffer, String(cacheKey));
      tx.oncomplete = () => resolve();
      tx.onerror = () => resolve();
    } catch {
      resolve();
    }
  });
}
